var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24.099,
    viewBox: "0 0 24 24.099",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18 174.019h-12a6 6 0 0 0 -6 6v12.1a6 6 0 0 0 6 6h12a6.005 6.005 0 0 0 6-6v-12.1a6.005 6.005 0 0 0 -6-6m3.776 18.1a3.78 3.78 0 0 1 -3.776 3.781h-12a3.78 3.78 0 0 1 -3.776-3.776v-7.824h4.742a5.7 5.7 0 1 0 10.312 0h4.5zm-12.021-5.4a2.366 2.366 0 1 1 2.365 2.365 2.368 2.368 0 0 1 -2.365-2.365m12.021-4.642h-6.357a5.675 5.675 0 0 0 -6.594 0h-6.6v-2.065a3.78 3.78 0 0 1 3.775-3.771h12a3.78 3.78 0 0 1 3.776 3.776zm-2.407-4.494h-2.057a.669.669 0 0 0 -.667.666v2.06a.669.669 0 0 0 .667.666h2.059a.668.668 0 0 0 .666-.666v-2.06a.668.668 0 0 0 -.666-.666",
    fill: "#fff",
    transform: "translate(0 -174.019)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.5b98d5e3ac3ce788eb65a2f6cb325cc6.svg";
export { ForwardRef as ReactComponent };